<template>
	<div class='route_container'>
		<div class="main_container px-5 py-5 mt-5">
			<div class="row">
				<!-- category sidebar -->
				<div class="col-lg-3 filter-column pr-lg-3 px-0 py-3">
					<fancy-input
						:placeholder='`${ $t("gifts_search") }...`'
						v-model='searchGiveaway'
						type="text"
						aria-label="Search"						
						ref="search"
						:large='true'
					></fancy-input>
					<ul id="filtersList" class="nav accordion d-flex flex-column flex-nowrap bg-gray-900 border border-green-lighter border-top-0  box-shadow my-3">
						<li class="nav-item py-3">
							<div class="d-flex row align-items-center justify-content-between m-0 px-2">
								<div class="categories-title d-flex row align-items-center col-11">
									<p class="h6 text-white mb-0 py-2">Browse</p>
								</div>
							</div>
							<router-link
								v-for='(category, $index) in categories'
								:key='"category-link-" + $index'

								class='threads_main__side_bar__menu_item'
								:to='`/${$store.state.meta.lang}/archive/` + category.value'
							>
								<span
									class='threads_main__side_bar__menu_item__border'
								></span>
								<span
									class='threads_main__side_bar__menu_item__text'
								>{{category.name}}</span>
							</router-link>
						</li>
					</ul>
				</div>
				<div class="col-lg-9 pl-lg-3 px-0">
					<h2 class="border-bottom border-green-lighter my-3"> Giveaways </h2>
					<!-- giveway list -->
					<div class="bg-gray-900 border border-green-lighter mt-3 px-3">
						<div class="table__row-outer-wrap" v-for="giveaway in giveaways" :key="giveaway.id">
							<div class="table__row-inner-wrap">
								<div>
									<router-link
										v-if="typeof(giveaway.thumbnail) !== 'undefined' || giveaway.thumbnail!==undefined"
										:to="`/${$store.state.meta.lang}/user`" 
										class="giveaway_image_thumbnail" 
										:style="{ 'background-image': 'url(' + giveaway.thumbnail + ')' }"
									>
									</router-link>
									
									<router-link
										v-else
										:to="`/${$store.state.meta.lang}/user`" 
										class="giveaway_image_thumbnail_missing" 
									>
										<font-awesome-icon :icon="['fa','image']" />
									</router-link>
								</div>
								<div class="table__column--width-fill">
									<p>
										<a class="table__column__heading" 
											:href="`/${$store.state.meta.lang}/giveaway/61gBS/outcast-second-contact`">{{giveaway.title}}</a>
									</p>
									<p>
										{{ $t('gifts_created') }} <span data-timestamp="1624076199">{{giveaway.post_time}}</span> {{ $t('gifts_ago') }} {{ $t("gifts_by") }} 
										<a 	class="table__column__secondary-link" 
											:href="`/${$store.state.meta.lang}/user/meerling`">{{giveaway.username}}</a>
									</p>
								</div>
								<div class="giveaway__columns">
									<div class="giveaway__column--invite-only" title="Invite Only" v-if="giveaway.invite"><font-awesome-icon :icon="['fa','lock']" /></div>
									<div class="giveaway__column--region-restricted" title="Region Restricted" v-if="giveaway.region"><font-awesome-icon :icon="['fa','globe']" /></div>
									<div class="giveaway__column--contributor-level giveaway__column--contributor-level--negative" title="Contributor Level" v-if="giveaway.level">{{ $t('gifts_level') }} {{giveaway.level}}+</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import FancyInput from '../FancyInput'

	export default {
		name: 'archive',
		components: {
			FancyInput
		},
		data () {
			return {
				choosed_color: "#00ff7f",
				choosed_back_color: "#00ff7f",
				categories: [
					{ "name": "All", "value": ""},
					{ "name": "Comming Soon", "value": "cooming-soon"}, 
					{ "name": "Open", "value": "open"},
					{ "name": "Closed", "value": "closed"},
					{ "name": "Deleted", "value": "deleted"}
				],
				searchGiveaway: "",
				errors: {
					content: '',
					name: '',
					pollQuestion: '',
					pollAnswer: ''
				},
				missed_avatar: require("./../../assets/img/new-home/missed_avatar.jpg"),
				giveaways: [
					{id:1, title: "Surviving Mars", value: "surviving-mars", thumbnail: require("./../../assets/img/new-home/thumbnail.jpg"), userid:1,username: 'Janzi', post_time: "2021-05-09", level: 7, invite: true, region: true},
					{id:2, title: "American Fugitive", value: "american-fugitive", thumbnail: require("./../../assets/img/new-home/thumbnail01.jpg"), userid:2, username: 'Alex', post_time: "2021-06-12", level: 2},
					{id:3, title: "Hurtworld", value: "hurtworld", thumbnail: require("./../../assets/img/new-home/thumbnail02.jpg"), userid:3, username: 'Smith', post_time: "2021-05-29", level: 3, invite: true},
					{id:4, title: "Tempest", value: "tempest", thumbnail: require("./../../assets/img/new-home/thumbnail03.jpg"), userid:4, username: 'Bronwse', post_time: "2021-03-19", level: 5},
					{id:5, title: "Hunter", value: "hunter", userid: 5, username: 'Elazabath', post_time: "2021-06-15", level: 6, region: true},
					{id:6, title: "Karakara", value: "karakara", userid: 5, username: 'Elazabath', post_time: "2021-06-16", level: 6, region: false},
					{id:7, title: "Gun", value: "gun", thumbnail: require("./../../assets/img/new-home/thumbnail04.png"), userid: 2, username: 'Alex', post_time: "2021-05-30", level: 2, invite:true,  region: true},
					{id:8, title: "Angvik", value: "angvik", userid: 10, username: 'Silmon', post_time: "2021-05-25", region: false},					
					{id:9, title: "Tempest", value: "tempest", thumbnail: require("./../../assets/img/new-home/thumbnail03.jpg"), userid: 2, username: 'Alex', post_time: "2021-05-25", level: 2, invite:true,  region: true},
				]
			}
		},
		watch: {
			searchGiveaway: function(){
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '../../assets/scss/elementStyles.scss';
	@import '../../assets/scss/variables.scss';
	@import '../../assets/scss/idec.scss';

	.router-link-exact-active span:first-child {
		background-color: $color__green--primary;
	}

	.router-link-exact-active span:last-child {
		color: $color__green--primary;
	}
	.threads_main {
		display: flex;

		&__side_bar{
			width: 12rem;
			height: 0%;
			background: #fff;
			margin-right: 1rem;
			border-radius: 0.25rem;
			border: thin solid $color__gray--darker;
			padding: 0.5rem 0 1rem 1rem;
			position: sticky;
			top: 4.5rem;

			@at-root #{&}__title {
				color: $color__darkgray--darker;
				cursor: default;
				font-weight: 500;
				font-size: 1.125rem;
			}

			@at-root #{&}__menu_item {
				cursor: pointer;
				margin-top: 0.5rem;
				position: relative;
				display: grid;
				grid-template-columns: 0.75rem auto;
				grid-column-gap: 1rem;
				text-decoration: none;
				background-image: none;
				font-weight: normal;
				margin-left: 1.5rem;

				span{
					color: #fff;
				}

				@at-root #{&}__border {
					align-self: center;
					display: inline-block;
					height: 0.9rem;
					width: 0.9rem;
					border-radius: 0.5rem;
					margin-top: 0;
					background-color: $color__gray--darkest;
					transition: all 0.2s;
				}

				@at-root #{&}__text {
					filter: saturate(0.75), brightness(0.75);
				}


				@at-root #{&}--selected {
					font-weight: 600;
				}
			}
		}

		&__load_new{
			@extend .button;

			font-size: 1.25rem;
			margin: 0 0 1rem 0;
			background-color: $color__lightgray--primary;
			border-color: $color__gray--darker;
			width: 100%;
			font-weight: 300;
		}
	}

	.table__row-outer-wrap{
		padding: 10px 0;
		border-right: 1px solid transparent;
		border-left: 1px solid transparent;
		font-size: 14px;

		.table__row-inner-wrap{
			display: flex;
			align-items: center;
			line-height: 1.3em;
			color: #fff;

			&>*:not(:last-child){
				padding-right: 1rem;
			}

			.table__column--width{
				&-fill{
					flex: 1;
				}
				&-small{
					width: 13%;
					min-width: 90px;
				}
				&-medium{
					width: 21%;
					min-width: 120px;
					display: flex;
					align-items: center;

					div{
						flex: 1;
					}
				}
			}
		}

		&:not(:last-of-type){
			border-bottom: 1px solid #d2d6e0;
		}
	}

	.giveaway__columns{
		display: flex;

		&>*:not(:last-child){
			margin-right: 5px;
		}
	}

	.giveaway__columns>*{
		white-space: nowrap;
		border-radius: 4px;
		font-size: 11px;
		border: 1px solid #d2d6e0;
		line-height: 26px;
		padding: 0 8px;
	}

	@media (max-width: $breakpoint--tablet) {
		.main_container{
			margin-top: 0!important;
		}
		.table__row-outer-wrap{
			overflow-x: auto;
			
			.table__row-inner-wrap, .table__heading{
				min-width: 600px;
			}
		}
	}
</style>
